import React, { createContext, forwardRef } from "react";
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import history from '../../history';
import { ViewDataCenterDashboard, ViewDataCenterDashboardFilters } from '../../Services/Actions';

import { FixedSizeList as List } from "react-window";
import AutoSizer from 'react-virtualized-auto-sizer';

import Filters from './Dashboard_Filter';
// import Header from './Header';

import * as styles from './styles';

import ButtonGroup from '../../Components/Buttons/ButtonGroup';
import Loading from '../../Components/Loading';
import PageText from '../../Components/Text/PageText';
import Spacer from '../../Components/Spacer';

import Info from '../../Modals/Info';

import { DynamicSort } from '../../Functions';

import DownArrow from '../../Assets/Icons/DownArrow.png';
import { ReactComponent as FilterSVG } from '../../Assets/SVG/Filter.svg';
import UpArrow from '../../Assets/Icons/UpArrow.png';

const ITEM_SIZE = 35;

const StickyListContext = createContext();
StickyListContext.displayName = "StickyListContext";

const TABLE_COLUMNS = [
    { Id: 1, SortCol: 'DisplayName', Title: 'Name' },
    { Id: 2, SortCol: 'Currency', Title: 'Currency' },
    { Id: 3, SortCol: 'ActiveStatus', Title: 'Status' },
    { Id: 4, SortCol: 'OrgNames', Title: 'Chain/Gym' },
    { Id: 5, SortCol: 'LastUsedBranch', Title: 'Last Used Branch' },
    { Id: 6, SortCol: 'AdminPrice', Title: 'Admin price' },
    { Id: 7, SortCol: 'PaidLast30', Title: 'Paid last 30' },
    { Id: 8, SortCol: 'PaidLast90', Title: 'Paid last 90' },
    { Id: 9, SortCol: 'PaidLast1Year', Title: 'Paid last year' },
    { Id: 10, SortCol: 'DisplayName', Title: 'Name' },
    { Id: 11, SortCol: 'SoldLast30', Title: 'Sold last 30' },
    { Id: 12, SortCol: 'SoldLast90', Title: 'Sold last 90' },
    { Id: 13, SortCol: 'SoldLast1Year', Title: 'Sold last year' },
    { Id: 14, SortCol: 'NumContracts30', Title: 'Contracts last 30' },
    { Id: 15, SortCol: 'NumContracts90', Title: 'Contracts last 90' },
    { Id: 16, SortCol: 'NumContracts1Year', Title: 'Contracts last year' },
    { Id: 17, SortCol: 'PendingPayments', Title: 'Pending payment (w/o fee)' },
    { Id: 18, SortCol: 'DisplayName', Title: 'Name' },
    { Id: 19, SortCol: 'NumPayingCustomers', Title: '# paying customers' },
    { Id: 20, SortCol: 'NumClients', Title: '# admin clients' },
    { Id: 21, SortCol: 'CompletedWeeklySessions', Title: '# weekly completed sessions for clients' },
    { Id: 22, SortCol: 'CompletedWeeklySessionsPercent', Title: 'Completion % clients' },
    { Id: 23, SortCol: 'TotalExerciseRecords', Title: '# exercise records for clients last 7 days' },
    { Id: 24, SortCol: 'MonthlySessionsForCoach', Title: 'Monthly completed sessions for coach' },
    { Id: 25, SortCol: 'DisplayName', Title: 'Name' }
]

const ListComponent = ({ items, Locale_Language, OnToggleSorting, SortCol: StateSortCol, SortDir: StateSortDir }) => {
    const Row = ({ index, style }) => {
        var { DisplayName, CurrencyName, AdminPrice, ActiveStatus, OrgNames, LastUsedBranch, SoldLast30, SoldLast90, SoldLast1Year, PaidLast30, PaidLast90, PaidLast1Year, NumContracts30, NumContracts90, NumContracts1Year, PendingPayments, NumPayingCustomers, NumClients, CompletedWeeklySessions, CompletedWeeklySessionsPercent, TotalExerciseRecords, MonthlySessionsForCoach } = items[index];

        return (
            <tr style={style}>
                <styles.TDCell Bold>{DisplayName}</styles.TDCell>
                <styles.TDCell>{CurrencyName}</styles.TDCell>
                <styles.TDCell>{ActiveStatus}</styles.TDCell>
                <styles.TDCell>{OrgNames}</styles.TDCell>
                <styles.TDCell>{LastUsedBranch}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(AdminPrice)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(PaidLast30)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(PaidLast90)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(PaidLast1Year)}</styles.TDCell>
                <styles.TDCell Bold>{DisplayName}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(SoldLast30)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(SoldLast90)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(SoldLast1Year)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(NumContracts30)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(NumContracts90)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(NumContracts1Year)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(PendingPayments)}</styles.TDCell>
                <styles.TDCell Bold>{DisplayName}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(NumPayingCustomers)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(NumClients)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(CompletedWeeklySessions)}</styles.TDCell>
                <styles.TDCell>{CompletedWeeklySessionsPercent}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(TotalExerciseRecords)}</styles.TDCell>
                <styles.TDCell IsNumber>{new Intl.NumberFormat(Locale_Language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(MonthlySessionsForCoach)}</styles.TDCell>
                <styles.TDCell Bold>{DisplayName}</styles.TDCell>
            </tr>
        );
    }

    const StickyRow = ({ style }) => (
        <tr className="sticky" style={style}>
            {
                TABLE_COLUMNS.map(({ Id, DataType, SortCol, Title }) => {
                    return (
                        <styles.THCell key={Id} onClick={() => OnToggleSorting({ SortCol })}>
                            <PageText FontFamily="semibold" FontSize="small" JustifyContent="flex-start" NoMargin TextAlign="left" Text={Title} />
                            {StateSortCol === SortCol && <styles.SortingIcon ImageSrc={StateSortDir === 'DESC' ? DownArrow : UpArrow} />}
                        </styles.THCell>
                    );
                })
            }
        </tr>
    );
    
    const StickyList = ({ children, stickyIndices, ...rest }) => (
        <StickyListContext.Provider value={{ ItemRenderer: children, stickyIndices }}>
            <List itemData={{ ItemRenderer: children, stickyIndices }} {...rest}>
                {ItemWrapper}
            </List>
        </StickyListContext.Provider>
    );
    
    const ItemWrapper = ({ data, index, style }) => {
        const { ItemRenderer, stickyIndices } = data;
    
        if (stickyIndices && stickyIndices.includes(index)) return null;
    
        return <ItemRenderer index={index} style={style} />;
    };
    
    const innerElementType = forwardRef(({ children, ...rest }, ref) => (
        <StickyListContext.Consumer>
            {() => (
                <table ref={ref} {...rest}>
                    <tbody>
                        <StickyRow style={{ top: 0, left: 0, width: "100%", height: ITEM_SIZE }} />
    
                        {children}
                    </tbody>
                </table>
            )}
        </StickyListContext.Consumer>
    ));

    return (
        <AutoSizer className="auto-sizer">
            {({ height, width }) => (
                <StickyList
                    className="data-center-table"
                    height={height}
                    innerElementType={innerElementType}
                    itemCount={items.length}
                    itemSize={ITEM_SIZE}
                    stickyIndices={[0]}
                    width={width}
                >
                    {Row}
                </StickyList>
            )}
        </AutoSizer>
    );
}

class DataCenter extends React.Component {
    state = {
        HasLoadedFilters: false,
        FirstLoad: false,
        FiltersUpdated: false,
        FilterOptions: {
            Branches: [],
            Organizations: [],
            SubscriptionStatus: [{ SubStatusId: 0, DisplayName: 'Inactive' }, { SubStatusId: 1, DisplayName: 'Active' }]
        },
        Filters: {
            Branches: [],
            DisplayName: '',
            Organizations: [],
            SubscriptionStatus: [],
        },
        Sorting: {
            SortCol: 'DisplayName',
            SortDir: 'ASC'
        },
        DataCenterDashboard: [],
        Locale_Language: +this.props.UserDetails.LanguageId === 2 ? 'no-NO' : 'en-US',
        ShowFiltersModals: false
    };
    
    componentDidMount() {
        if (!this.props.UserDetails.DataCenterAccess) history.push('/clients');
        // else this.onLoadDataCenter()
    }

    onBlurFilter = () => {
        if (this.state.FiltersUpdated) {
            this.setState({ FiltersUpdated: false, PageNo: 1 }, () => {
                this.onLoadDataCenter();
            })
        }
    }
    
    onChangeFilter = ({ Data, Type }) => {
        var Filters = { ...this.state.Filters };
        Filters[Type] = Data;

        // this.setState({ Filters, FiltersUpdated: true });

        this.setState({ Filters, PageNo: 1 }, () => {
            this.onLoadDataCenter();
        })
    }

    onLoadFilters = () => {
        if (this.state.HasLoadedFilters) return null;

        this.props.ViewDataCenterDashboardFilters().then(({ Branches, Organizations }) => {
            var FilterOptions = { ...this.state.FilterOptions, Branches, Organizations };
            this.setState({ HasLoadedFilters: true, FilterOptions });
        })
    }

    onLoadDataCenter = () => {
        var { Filters, Sorting } = this.state;
        var { Branches, Organizations, SubscriptionStatus } = Filters;

        var BranchIds = Branches.map(({ BranchId }) => BranchId).join(',');
        var OrgIds = Organizations.map(({ OrganizationId }) => OrganizationId).join(',');
        var SubStatus = SubscriptionStatus.map(({ SubStatusId }) => SubStatusId).join(',');
        var { SortCol, SortDir } = Sorting;

        this.props.ViewDataCenterDashboard({ BranchIds, OrgIds, SortCol, SortDir, SubStatus }).then(({ DataCenterDashboard }) => {
            if (DataCenterDashboard.length) DataCenterDashboard = [ { DisplayName: '' }, ...DataCenterDashboard ]; // Add Empty Row Which Hides Behind Sticky Row
            this.setState({ FirstLoad: true, DataCenterDashboard });
        })
    }

    onToggleShowFiltersModal = ShowFiltersModals => {
        this.setState({ ShowFiltersModals });
    }

    onToggleSorting = ({ SortCol: NewSortCol }) => {
        if (!this.state.DataCenterDashboard.length) return null;

        var { SortCol, SortDir } = this.state.Sorting;

        // SortDir Goes From ASC --> DESC --> Nothing

        // Toggle Sorting Of Already Sorted Column
            if (SortCol === NewSortCol) {
                if (SortDir === 'ASC') SortDir = 'DESC';
                else if (SortDir === 'DESC') {
                    SortDir = '';
                    SortCol = '';
                }
                else if (SortDir === '') SortDir = 'ASC';
            }
        // Start Sorting On New Column
            else {
                SortCol = NewSortCol;
                SortDir = 'ASC';
            }

        // Remove first empty object
            var DataCenterDashboard = [ ...this.state.DataCenterDashboard ];
            DataCenterDashboard.splice(0, 1)

        // Sort and Add Empty Object In Again
            var NewDataCenterDashboard = [ { DisplayName: '' }, ...DataCenterDashboard.sort(DynamicSort({ SortCol, SortDir })) ];

        this.setState({ DataCenterDashboard: NewDataCenterDashboard, Sorting: { SortCol, SortDir }})
    }

    onTypeSearchInput = ({ ContentType, Text }) => {
        var Filters = { ...this.state.Filters };
        Filters[ContentType] = Text;

        this.setState({ Filters });
    }

    renderBody = () => {
        var { t } = this.props;
        var { Device, TryingGetDataCenterDashboardFilters } = this.props;
        var { Branches, DisplayName, Organizations, SubscriptionStatus } = this.state.FilterOptions;

        return (
            <>
                {/* {<Header PageTitle={this.props.PageTitle} />} */}

                {
                    Device === 'laptop' &&
                    <Filters
                        Branches={Branches}
                        DisplayName={DisplayName}
                        Organizations={Organizations}
                        SubscriptionStatus={SubscriptionStatus}
                        Loading={TryingGetDataCenterDashboardFilters}
                        OnBlurFilter={this.onBlurFilter}
                        OnChangeFilter={this.onChangeFilter}
                        OnFocusFilter={this.onLoadFilters}
                        OnTypeSearchInput={this.onTypeSearchInput}
                    />
                }

                <styles.BodyContainer className="BodyContainer">
                    {
                        Device !== 'laptop' &&
                        <>
                            <ButtonGroup
                                Buttons={[{ BackgroundColor: "white-concrete", BackgroundColorHover: 'white-concrete-hover', Border: 'none', Color: 'black', ColorHover: 'black', IconOnly: true, IconSVG: FilterSVG, IconSVGColor: 'black', IconPosition: 'left', OnClick: () => this.onToggleShowFiltersModal(true), Title: t('_select_filters') }]}
                                NotTouching
                            />

                            <Spacer Size="small" />
                        </>
                    }

                    <PageText FontFamily="medium-italic" FontSize="small" JustifyContent="flex-start" NoMargin TextAlign="left" Text={`Num Coaches: ${this.state.DataCenterDashboard.length ? this.state.DataCenterDashboard.length - 1 : 0}`} />

                    {this.renderDashboard()}
                </styles.BodyContainer>
            </>
        );
    }

    renderDashboard = () => {
        var { DataCenterDashboard, Filters, Sorting: { SortCol, SortDir } } = this.state;

        if (!DataCenterDashboard.length) return null;

        if (Filters.DisplayName !== '') DataCenterDashboard = DataCenterDashboard.filter(Trainer => (Trainer.DisplayName.toLowerCase().indexOf(Filters.DisplayName.toLowerCase()) > -1 || Trainer.DisplayName === ''));

        return <ListComponent items={DataCenterDashboard} OnToggleSorting={this.onToggleSorting} SortCol={SortCol} SortDir={SortDir} />
    }

    renderFiltersModal_Info = () => {
        var { TryingGetDataCenterDashboard, TryingGetDataCenterDashboardFilters } = this.props;
        var { Branches, DisplayName, Organizations, SubscriptionStatus } = this.state.FilterOptions;
        var { Branches: SelectedBranches, Organizations: SelectedOrganizations, SubscriptionStatus: SelectedSubscriptionStatus } = this.state.Filters;
        
        return (
            <Filters
                Branches={Branches}
                DisplayName={DisplayName}
                Organizations={Organizations}
                SubscriptionStatus={SubscriptionStatus}
                SelectedContent={{
                    Branches: SelectedBranches,
                    Organizations: SelectedOrganizations,
                    SubscriptionStatus: SelectedSubscriptionStatus
                }}
                IsModal
                Loading={TryingGetDataCenterDashboard || TryingGetDataCenterDashboardFilters}
                OnBlurFilter={this.onBlurFilter}
                OnChangeFilter={this.onChangeFilter}
                OnFocusFilter={this.onLoadFilters}
            />
        );
    }

    renderFiltersModal = () => {
        var { ShowFiltersModals } = this.state;

        if (ShowFiltersModals) {
            return (
                <Info
                    BottomButton={null}
                    InformationRenderer={this.renderFiltersModal_Info}
                    OnHide={() => this.onToggleShowFiltersModal(false)}
                    Show={ShowFiltersModals}
                />
            );
        }
    }

    render() {
        var { TryingGetDataCenterDashboard, TryingGetDataCenterDashboardFilters } = this.props;

        return (
            <>
                {(TryingGetDataCenterDashboard || TryingGetDataCenterDashboardFilters) && <Loading />}

                {this.renderBody()}

                {this.renderFiltersModal()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        Device: state.Window.Device,

        UserDetails: state.Auth.UserDetails,

        TryingGetDataCenterDashboard: state.DataCenter.TryingGetDataCenterDashboard,
        TryingGetDataCenterDashboardError: state.DataCenter.TryingGetDataCenterDashboardError,
        TryingGetDataCenterDashboardFilters: state.DataCenter.TryingGetDataCenterDashboardFilters,
        TryingGetDataCenterDashboardFiltersError: state.DataCenter.TryingGetDataCenterDashboardFiltersError
    };
};

export default withTranslation()(connect(mapStateToProps, { ViewDataCenterDashboard, ViewDataCenterDashboardFilters })(DataCenter));